export default __webpack_public_path__ + "static/media/10.77352628.png";